import { render, staticRenderFns } from "./ExportPersonnelProvisions.vue?vue&type=template&id=3819571e&scoped=true&"
import script from "./ExportPersonnelProvisions.vue?vue&type=script&lang=js&"
export * from "./ExportPersonnelProvisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3819571e",
  null
  
)

export default component.exports